import { useState } from "react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Is there an age requirement?",
      answer: "HVY is a group for members 18 years and older. Applicants must meet this age requirement.",
    },
    {
      question: "Can I join HVY if I'm in another group?",
      answer: "HVY prohibits multi-clan memberships. Members found in other DCS groups may have their membership revoked.",
    },
    {
      question: "Do you fly red aircraft (e.g., Hind, Mig-21)?",
      answer: "HVY operates NATO-aligned squadrons. You can use red aircraft on public servers but must join a blue squadron for membership.",
    },
    {
      question: "I'm new to DCS. Can I join?",
      answer: "Absolutely! Our members are happy to help new pilots learn and improve in their chosen airframe.",
    },
    {
      question: "Will I need to manage mods?",
      answer: "Beyond a few required mods and livery packs, setup is straightforward for participation in HVY.",
    },
    {
      question: "Are there certifications or qualifications?",
      answer: "New members complete a basic checkflight. Squadrons may have additional qualifications.",
    },
    {
      question: "How hardcore is HVY's milsim approach?",
      answer: "HVY balances realism with fun. Real-life procedures are followed where appropriate, but it's not overly strict.",
    },
    {
      question: "What policies should I know about?",
      answer: "HVY enforces zero tolerance for hate speech, racism, and harassment. Avoid political discussions.",
    },
  ];

  // FAQPage structured data, built from the same `faqs` source so it can't
  // drift from the visible questions. Lives here (not index.html) so it only
  // ships on the home page, where the FAQ is actually rendered.
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: { '@type': 'Answer', text: f.answer },
    })),
  };

  return (
    <section id="faq" className="py-16 scroll-mt-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <h3 className="font-heading text-3xl font-bold tracking-tight uppercase text-hvy-900 mb-8">
        Frequently Asked Questions
      </h3>
      <div className="bg-white/60 backdrop-blur-sm rounded-xl shadow-sm border border-gray-200/50 divide-y divide-gray-200/50">
        {faqs.map((faq, index) => (
          <div key={index} className="px-6">
            <button
              type="button"
              className="flex w-full items-center justify-between text-left py-5 group"
              aria-expanded={activeIndex === index}
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-base font-semibold text-gray-900 group-hover:text-hvy-500 transition-colors">
                {faq.question}
              </span>
              <span className="ml-6 flex-shrink-0">
                <svg
                  className={`h-5 w-5 text-gray-400 transition-transform duration-300 ${
                    activeIndex === index ? "rotate-180" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </button>
            <div
              className={`faq-answer ${activeIndex === index ? "open" : ""}`}
            >
              <p className="pb-5 text-base leading-7 text-gray-600">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
